module.exports = __webpack_public_path__ + "static/img/brid_details.558c0d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/brid_details.png
// module id = UKlE
// module chunks = 1 3